import { render, staticRenderFns } from "./PreviousPrescription.vue?vue&type=template&id=c43a79bc"
import script from "./PreviousPrescription.vue?vue&type=script&lang=js"
export * from "./PreviousPrescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports